import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'collectionNames',
    standalone: false
})
export class CollectionNamesPipe implements PipeTransform {
  transform(collections: ({ name?: string | null | undefined } | null)[] | null | undefined): string {
    if (!collections || collections.length === 0) {
      return '';
    }

    return collections
      .map(item => item?.name ?? '')
      .filter(name => name.trim() !== '')
      .join(', ');
  }
}
